import { InsurancePolicy } from '@advisory-report/src/types/AdvisoryReport';
import { useQuery } from 'react-query';
import { wgApi } from '../../../../../../app/src/features/api/wgApi';

interface Params {
  insurancePolicyId: string;
}

const getInsurancePolicy = async ({ insurancePolicyId }: Params) => {
  const path = `/v1/api/insurance-policies/${insurancePolicyId}`;
  const { data, isError } = await wgApi.get<InsurancePolicy>(path);
  if (isError) throw new Error('Error fetching insurance policies');
  return data;
};

export const getUseInsurancePolicyQkey = ({ insurancePolicyId }: Params) => [
  'parties',
  'insurance-policy',
  insurancePolicyId,
];

export const useInsurancePolicy = (params: Params) => {
  return useQuery(
    getUseInsurancePolicyQkey(params),
    () => getInsurancePolicy(params),
    {
      enabled: !!params.insurancePolicyId,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  );
};
